import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TextFieldModule } from '@angular/cdk/text-field';

@Component({
  selector: 'app-resizable-textarea',
  standalone: true,
  imports: [CommonModule, FormsModule, TextFieldModule],
  templateUrl: './resizable-textarea.component.html',
  styleUrls: ['./resizable-textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ResizableTextareaComponent),
      multi: true
    }
  ]
})
export class ResizableTextareaComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() minRows: number = 2;
  @Input() autofocus: boolean = false;
  
  value: string = '';

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(val: any): void {
    if (val !== undefined) {
      this.value = val;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Optional: implement disabled state logic
  }

  onInputChange(val: string) {
    this.value = val;
    this.onChange(val);
    this.onTouched();
  }
}
